import { render } from "./CaseVideoPage.vue?vue&type=template&id=1a9f46a5"
import script from "./CaseVideoPage.vue?vue&type=script&lang=js"
export * from "./CaseVideoPage.vue?vue&type=script&lang=js"

import "./CaseVideoPage.vue?vue&type=style&index=0&id=1a9f46a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__